import {z} from '@hono/zod-openapi';

export const AutoplacPlFeedTenantParamsSchema = z
  .object({tenantId: z.string().uuid()})
  .openapi('AutoplacPlFeedTenantParams');
